"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import PopularCategories from "../../elements/swipers/PopularCategories";
import { useTrackView } from "@/app/hooks/useTrackView";

interface PopularCategoriesSectionProps {
  categories?: SectionItem[];
  title?: string;
  sectionId?: number;
}

const PopularCategoriesSection = ({
  categories,
  title,
  sectionId,
}: PopularCategoriesSectionProps) => {
  const trackRef = useTrackView("section", sectionId);

  return (
    <section ref={trackRef}>
      <h2 className="text-lg sm:text-xl font-medium mb-2 sm:mb-3">
        {title || "Her Bütçeye Göre Ürün"}
      </h2>
      <PopularCategories categories={categories} />
    </section>
  );
};

export default PopularCategoriesSection;
